import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configurerLeClient } from '../shared/api/client';
import { Routeur } from './Routeur';
import './styles.css';

/**
 * **Le démarrage du site vitrine.**
 *
 * **Plus léger que celui de `web/`, et pour une raison** : ce site n'a **aucune donnée
 * protégée** à afficher. Il n'y a donc ni portail de session, ni traitement de `401`, ni
 * vidage de cache — l'unique appel d'API qu'il fait est celui qui ouvre une session, et
 * la personne quitte ce domaine juste après.
 */
configurerLeClient();

const racine = document.getElementById('racine');
if (racine === null) {
  throw new Error('La racine du document est introuvable.');
}

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={new QueryClient()}>
      <Routeur />
    </QueryClientProvider>
  </StrictMode>,
);
